<template>
  <div class="wrapper-loading">
    <img src="assets/logo/logo-polpum.svg" alt="" width="201px" height="87px" class="mb-5" />
    <b-spinner v-if="status == ''" large></b-spinner>
    <span v-if="status == 'error'">{{ errorMessage }}</span>
  </div>
</template>

<style scoped>
.wrapper-loading {
  height: 100%;
  width: 100%;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  position: fixed;
}
</style>

<script>
import Swal from "sweetalert2";

export default {
  data() {
    return {
      status: '',
      errorMessage: 'Gagal login...'
    }
  },
  mounted() {
    this.handleCallback()
  },
  methods: {
    handleCallback() {
      // Backend redirects here with ?token={app_jwt}&is_sso=1
      var accessToken = this.$route.query.token || this.$route.query.access_token

      if (!accessToken) {
        this.status = 'error'
        this.errorMessage = 'Token tidak ditemukan'
        Swal.fire({
          icon: 'warning',
          title: 'Gagal melakukan autentikasi SSO',
          text: 'Token tidak ditemukan dari server',
          confirmButtonColor: "#063A69",
          confirmButtonText: "Ok"
        }).then(() => {
          this.$router.push({ name: 'polpum' })
        })
        return
      }

      // Store the app JWT and fetch user profile data
      this.$store
        .dispatch("loginSsoCallback", accessToken)
        .then(() => {
          this.$router.push({ name: "dashboard" })
        })
        .catch(error => {
          this.status = 'error'
          Swal.fire({
            icon: 'warning',
            title: error.message || 'Gagal login SSO',
            confirmButtonColor: "#063A69",
            confirmButtonText: "Ok"
          }).then(() => {
            this.$router.push({ name: 'polpum' })
          })
        })
    }
  }
}
</script>
